import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import DataTable from '../DataTable';
import { toJS } from 'mobx';
import Spinner from '../Spinner';

@inject('requestStore')
@observer
class RequestList extends Component {
  static propTypes = {
    // params: PropTypes.shape().isRequired,
    route: PropTypes.shape().isRequired,
    children: PropTypes.node,
  }

  componentWillMount() {
    const { requestStore } = this.props;
    if(!requestStore.items.length) requestStore.fetchItems();
  }

  slug = '/daq/request';
  columns = [
    { key: 'id', label: 'ID' },
    { key: 'daq_processor_parser', label: 'DAQ Processor' },
    { key: 'payload', label: 'Payload' },
  ];

  actions = [
    { label: 'Detail', link: '/daq/request/{id}' },
    // { label: 'Raw Data', link: '/request/{id}/raw-data' },
    // { label: 'Observations', link: '/request/{id}/observation' },
    // { label: 'Origin Data', link: '/request/{id}/origin-data' },
  ];

  render() {
    const { requestStore, children } = this.props;

    if (requestStore.isLoading) return <Spinner />;

    return (
      <div>
        <DataTable
          caption={'Requests'}
          data={toJS(requestStore.items)}
          slug={this.slug}
          columns={this.columns}
          actions={this.actions}
          readOnly
        />
        {children}
      </div>
    );
  }
}

export default RequestList;



// WEBPACK FOOTER //
// ./src/components/Request/RequestList.js